import { render, staticRenderFns } from "./provideOrganizationInfo.vue?vue&type=template&id=73b982b4&scoped=true&"
import script from "./provideOrganizationInfo.vue?vue&type=script&lang=js&"
export * from "./provideOrganizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./provideOrganizationInfo.vue?vue&type=style&index=0&id=73b982b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b982b4",
  null
  
)

export default component.exports